export default __webpack_public_path__ + "static/media/linus.c08bc630.webp";